module.exports = __webpack_public_path__ + "img/046-wash.b0665855.svg";